const globalDayWeekMonthParams = {
  region_type: 'region',
  regions: ['global'],
  granularity: ['daily', 'weekly', 'monthly'],
};
const globalMonthlyParams = {
  region_type: 'market',
  regions: ['global'],
  granularity: ['monthly'],
};
const usMonthlyParams = {
  region_type: 'market',
  regions: ['us'],
  granularity: ['monthly'],
};

export const hasDataTimerParams = {
  mobileActiveuser: {
    //model类型
    type: 'mobileActiveuser',
    //参数
    params: {
      ...globalDayWeekMonthParams,
      entity_type: 'mobile',
      source_metric: {
        sensortower: ['dau'],
      },
    },
  },
  mobileRevenue: {
    type: 'mobileRevenue',
    params: {
      ...globalDayWeekMonthParams,
      entity_type: 'mobile',
      source_metric: {
        sensortower: ['revenue'],
      },
    },
  },
  mobileDownload: {
    type: 'mobileDownload',
    params: {
      ...globalDayWeekMonthParams,
      entity_type: 'mobile',
      source_metric: {
        sensortower: ['download'],
      },
    },
  },
  mobileDatabrain: {
    type: 'mobileDatabrain',
    params: {
      entity_type: 'mobile',
      ...globalDayWeekMonthParams,
      source_metric: {
        ogdb: ['dau'],
      },
    },
  },
  mobileRpd: {
    type: 'mobileRpd',
    params: {
      ...globalDayWeekMonthParams,
      entity_type: 'mobile',
      source_metric: {
        appannie: ['cumulative_revenue', 'cumulative_downloads'],
      },
    },
  },
  mobileRetention: {
    type: 'mobileRetention',
    params: {
      entity_type: 'mobile',
      ...globalMonthlyParams,
      source_metric: {
        appannie: ['retention'],
      },
    },
  },
  mobileDemographics: {
    type: 'mobileDemographics',
    params: {
      entity_type: 'mobile',
      ...usMonthlyParams,
      source_metric: {
        'appannie demographics monthly': ['breakdown'],
      },
    },
  },
  pcMetricTable: {
    type: 'pcMetricTable',
    params: {
      entity_type: 'pc',
      ...globalDayWeekMonthParams,
      source_metric: {
        // steamcharts: ['pcu'],
        // PC Games - PCU 已切到 gamalytic 数据源，这里补齐 gamalytic 的默认有数据时间
        gamalytic: ['gamalytic__pcu'],
      },
    },
  },
  pcPUC: {
    type: 'pcPUC',
    params: {
      entity_type: 'pc',
      ...globalDayWeekMonthParams,
      source_metric: {
        // steamcharts: ['pcu'],
        gamalytic: ['gamalytic__pcu'],
      },
    },
  },
  pcDigitalRevenue: {
    type: 'pcDigitalRevenue',
    params: {
      ...globalDayWeekMonthParams,
      entity_type: 'pc',
      source_metric: {
        mscience: ['revenue'],
      },
    },
  },
  pcPhysicalRevenue: {
    type: 'pcPhysicalRevenue',
    params: {
      entity_type: 'pc',
      ...usMonthlyParams,
      source_metric: {
        npd: ['revenue'],
      },
    },
  },
  pcSteamSales: {
    type: 'pcSteamSales',
    params: {
      entity_type: 'pc',
      ...globalDayWeekMonthParams,
      source_metric: {
        gamalytic: ['gamalytic__est_revenue'],
      },
    },
  },
  pcMAU: {
    type: 'pcMAU',
    params: {
      entity_type: 'pc',
      ...globalMonthlyParams,
      source_metric: {
        newzoo: ['mau'],
      },
    },
  },
  pcLifetimePlayers: {
    type: 'pcLifetimePlayers',
    params: {
      entity_type: 'pc',
      ...globalMonthlyParams,
      source_metric: {
        newzoo: ['lifetime_player'],
      },
    },
  },
  consoleMetricTable: {
    type: 'consoleMetricTable',
    params: {
      entity_type: 'console',
      ...globalDayWeekMonthParams,
      source_metric: {
        mscience: ['revenue'],
      },
    },
  },
  consoleDigitalRevenue: {
    type: 'consoleDigitalRevenue',
    params: {
      entity_type: 'console',
      ...globalDayWeekMonthParams,
      source_metric: {
        mscience: ['revenue'],
      },
    },
  },
  consolePhysicalRevenue: {
    type: 'consolePhysicalRevenue',
    params: {
      entity_type: 'console',
      ...usMonthlyParams,
      source_metric: {
        npd: ['revenue'],
      },
    },
  },
  consoleJapanSales: {
    type: 'consoleJapanSales',
    params: {
      entity_type: 'console',
      region_type: '',
      regions: [],
      granularity: ['weekly'],
      source_metric: {
        'famitsu rank': ['usd_price'],
      },
    },
  },
  consoleMAU: {
    type: 'consoleMAU',
    params: {
      entity_type: 'console',
      ...globalMonthlyParams,
      source_metric: {
        newzoo: ['mau'],
      },
    },
  },
  consoleLifetimePlayers: {
    type: 'consoleLifetimePlayers',
    params: {
      entity_type: 'console',
      ...globalMonthlyParams,
      source_metric: {
        newzoo: ['lifetime_player'],
      },
    },
  },
  combileMetricTable: {
    type: 'combileMetricTable',
    params: {
      entity_type: 'combine',
      ...globalDayWeekMonthParams,
      source_metric: {
        // steamcharts: ['pcu'],
        gamalytic: ['gamalytic__pcu'],
      },
    },
  },
  companiesRevenue: {
    type: 'companiesRevenue',
    params: {
      entity_type: 'company',
      region_type: 'region',
      regions: ['global'],
      granularity: ['daily', 'weekly', 'yearly', 'monthly'],
      source_metric: {
        appannie: ['revenue'],
        company_mscience: ['revenue'],
        company_npd: ['revenue'],
      },
    },
  },
  companiesDownloads: {
    type: 'companiesDownloads',
    params: {
      entity_type: 'company',
      ...globalDayWeekMonthParams,
      source_metric: {
        appannie: ['download'],
      },
    },
  },
  companiesMentions: {
    type: 'companiesMentions',
    params: {
      entity_type: 'company',
      ...globalDayWeekMonthParams,
      source_metric: {
        company_rention: ['mentions'],
      },
    },
  },
  storerankMobileTopcharts: {
    type: 'storerankMobileTopcharts',
    params: {
      entity_type: 'mobile',
      region_type: 'market',
      regions: ['us'],
      granularity: ['daily'],
      source_metric: {
        'appstore top free': ['rank'],
        'appstore top grossing': ['rank'],
        'appstore top paid': ['rank'],
      },
    },
  },
  storerankMobileGlobalCompare: {
    type: 'storerankMobileGlobalCompare',
    params: {
      entity_type: 'mobile',
      region_type: 'market',
      regions: [
        'ng',
        'za',
        'hk',
        'tw',
        'cn',
        'cz',
        'gr',
        'hu',
        'pl',
        'ru',
        'tr',
        'in',
        'pk',
        'jp',
        'dz',
        'bh',
        'eg',
        'iq',
        'il',
        'jo',
        'kw',
        'lb',
        'ly',
        'ma',
        'om',
        'qa',
        'sa',
        'tn',
        'ae',
        'ye',
        'ca',
        'us',
        'au',
        'nz',
        'ar',
        'bo',
        'br',
        'cl',
        'co',
        'ec',
        'sv',
        'mx',
        'py',
        'pe',
        'uy',
        'kr',
        'id',
        'my',
        'ph',
        'sg',
        'th',
        'vn',
        'at',
        'dk',
        'fi',
        'fr',
        'de',
        'ie',
        'it',
        'nl',
        'pt',
        'es',
        'se',
        'ch',
        'gb',
      ],
      granularity: ['daily'],
      source_metric: {
        'appstore top free': ['rank'],
      },
    },
  },
  storerankMobileDetailTopFree: {
    type: 'storerankMobileDetailTopFree',
    params: {
      entity_type: 'mobile',
      region_type: 'market',
      regions: [
        'ng',
        'za',
        'hk',
        'tw',
        'cn',
        'cz',
        'gr',
        'hu',
        'pl',
        'ru',
        'tr',
        'in',
        'pk',
        'jp',
        'dz',
        'bh',
        'eg',
        'iq',
        'il',
        'jo',
        'kw',
        'lb',
        'ly',
        'ma',
        'om',
        'qa',
        'sa',
        'tn',
        'ae',
        'ye',
        'ca',
        'us',
        'au',
        'nz',
        'ar',
        'bo',
        'br',
        'cl',
        'co',
        'ec',
        'sv',
        'mx',
        'py',
        'pe',
        'uy',
        'kr',
        'id',
        'my',
        'ph',
        'sg',
        'th',
        'vn',
        'at',
        'dk',
        'fi',
        'fr',
        'de',
        'ie',
        'it',
        'nl',
        'pt',
        'es',
        'se',
        'ch',
        'gb',
      ],
      granularity: ['daily'],
      source_metric: {
        'appstore top free': ['rank'],
      },
    },
  },
  storerankMobileDetailTopGrossing: {
    type: 'storerankMobileDetailTopGrossing',
    params: {
      entity_type: 'mobile',
      region_type: 'market',
      regions: [
        'ng',
        'za',
        'hk',
        'tw',
        'cn',
        'cz',
        'gr',
        'hu',
        'pl',
        'ru',
        'tr',
        'in',
        'pk',
        'jp',
        'dz',
        'bh',
        'eg',
        'iq',
        'il',
        'jo',
        'kw',
        'lb',
        'ly',
        'ma',
        'om',
        'qa',
        'sa',
        'tn',
        'ae',
        'ye',
        'ca',
        'us',
        'au',
        'nz',
        'ar',
        'bo',
        'br',
        'cl',
        'co',
        'ec',
        'sv',
        'mx',
        'py',
        'pe',
        'uy',
        'kr',
        'id',
        'my',
        'ph',
        'sg',
        'th',
        'vn',
        'at',
        'dk',
        'fi',
        'fr',
        'de',
        'ie',
        'it',
        'nl',
        'pt',
        'es',
        'se',
        'ch',
        'gb',
      ],
      granularity: ['daily'],
      source_metric: {
        'appstore top grossing': ['rank'],
      },
    },
  },
  storerankMobileDetailTopPaid: {
    type: 'storerankMobileDetailTopPaid',
    params: {
      entity_type: 'mobile',
      region_type: 'market',
      regions: [
        'ng',
        'za',
        'hk',
        'tw',
        'cn',
        'cz',
        'gr',
        'hu',
        'pl',
        'ru',
        'tr',
        'in',
        'pk',
        'jp',
        'dz',
        'bh',
        'eg',
        'iq',
        'il',
        'jo',
        'kw',
        'lb',
        'ly',
        'ma',
        'om',
        'qa',
        'sa',
        'tn',
        'ae',
        'ye',
        'ca',
        'us',
        'au',
        'nz',
        'ar',
        'bo',
        'br',
        'cl',
        'co',
        'ec',
        'sv',
        'mx',
        'py',
        'pe',
        'uy',
        'kr',
        'id',
        'my',
        'ph',
        'sg',
        'th',
        'vn',
        'at',
        'dk',
        'fi',
        'fr',
        'de',
        'ie',
        'it',
        'nl',
        'pt',
        'es',
        'se',
        'ch',
        'gb',
      ],
      granularity: ['daily'],
      source_metric: {
        'appstore top paid': ['rank'],
      },
    },
  },
  compareMobileActiveuser: {
    type: 'compareMobileActiveuser',
    params: {
      entity_type: 'mobile',
      region_type: 'market',
      regions: ['global'],
      granularity: ['daily', 'weekly', 'monthly'],
      tab_type: 'compare_mobile_activeuser',
      source_metric: {
        appannie: ['dau'],
        ogdb_appannie: ['dau'],
        sensortower: ['dau'],
      },
    },
  },
  compareMobileRevenue: {
    type: 'compareMobileRevenue',
    params: {
      entity_type: 'mobile',
      tab_type: 'compare_mobile_revenue',
      ...globalDayWeekMonthParams,
      source_metric: {
        appannie: ['revenue'],
      },
    },
  },
  compareMobileDownlaods: {
    type: 'compareMobileDownlaods',
    params: {
      entity_type: 'mobile',
      tab_type: 'compare_mobile_downlaods',
      ...globalDayWeekMonthParams,
      source_metric: {
        appannie: ['download'],
      },
    },
  },
  compareMobileStoreRank: {
    type: 'compareMobileStoreRank',
    params: {
      entity_type: 'mobile',
      tab_type: 'compare_mobile_storerank',
      region_type: 'market',
      regions: [
        'ng',
        'za',
        'hk',
        'tw',
        'cn',
        'cz',
        'gr',
        'hu',
        'pl',
        'ru',
        'tr',
        'in',
        'pk',
        'jp',
        'dz',
        'bh',
        'eg',
        'iq',
        'il',
        'jo',
        'kw',
        'lb',
        'ly',
        'ma',
        'om',
        'qa',
        'sa',
        'tn',
        'ae',
        'ye',
        'ca',
        'us',
        'au',
        'nz',
        'ar',
        'bo',
        'br',
        'cl',
        'co',
        'ec',
        'sv',
        'mx',
        'py',
        'pe',
        'uy',
        'kr',
        'id',
        'my',
        'ph',
        'sg',
        'th',
        'vn',
        'at',
        'dk',
        'fi',
        'fr',
        'de',
        'ie',
        'it',
        'nl',
        'pt',
        'es',
        'se',
        'ch',
        'gb',
      ],
      granularity: ['daily'],
      source_metric: {
        'appstore top free': ['rank'],
      },
    },
  },
  comparePCMau: {
    type: 'comparePCMau',
    params: {
      entity_type: 'combine',
      tab_type: 'compare_combine_mau',
      ...globalMonthlyParams,
      source_metric: {
        newzoo: ['mau'],
      },
    },
  },
  comparePCDigitalRevenue: {
    type: 'comparePCDigitalRevenue',
    params: {
      entity_type: 'combine',
      tab_type: 'compare_combine_digital',
      ...globalDayWeekMonthParams,
      source_metric: {
        mscience: ['revenue'],
      },
    },
  },
  streamingInfluencerDetail: {
    type: 'streamingInfluencerDetail',
    params: {
      entity_type: 'kol',
      region_type: '',
      regions: [],
      granularity: ['daily', 'weekly', 'monthly'],
      source_metric: {
        kol: ['hoursWatched'],
      },
    },
  },
  streamingGame: {
    type: 'streamingGame',
    params: {
      entity_type: 'stream',
      region_type: '',
      regions: [],
      granularity: ['daily', 'weekly', 'monthly'],
      source_metric: {
        stream: ['hoursWatched'],
      },
    },
  },
  overlapAnalysis: {
    type: 'overlapAnalysis',
    params: {
      entity_type: 'mobile',
      region_type: 'market',
      regions: ['us'],
      granularity: ['monthly'],
      source_metric: {
        cross_app: ['cross_app_usage', 'cross_affinity'],
      },
    },
  },
  mobileUpcoming: { type: 'mobileUpcoming', params: {} },
  pcUpcoming: { type: 'pcUpcoming', params: {} },
  consoleUpcoming: { type: 'consoleUpcoming', params: {} },
} as any;
